import { createAuthInstance } from './general'

export function getMtAddress () {
  return process.env.VUE_APP_READER_API_HOST
}

const mt = () => createAuthInstance(getMtAddress())

export const removeWorkspace = (name) => {
  return mt().delete(`remove-workspace/${name}`)
}

export const createWorkspace = (name, description, type) => {
  return mt().post('create-workspace', {
    name,
    description,
    type
  })
}

export const cloneWorkspace = (name, description, template) => {
  return mt().post('clone-workspace', {
    name,
    description,
    template
  })
}

export const releaseWorkspace = (name, release_name) => {
  return mt().post('release-workspace', {
    name,
    release_name
  })
}

export const releaseWorkspaceCheck = (name) => {
  return mt().get(['release-workspace-check', name].join('/'))
}

export const releaseWorkspacesCheck = (names) => {
  return mt().post('release-workspaces-check', { names })
}

export const getAnnexes = (workspace, namespace) => {
  return mt().get(`get-annexes/${workspace}/${namespace}`)
}

export const updateAnnexes = (workspace, namespace, updates) => {
  return mt().post(`update-annexes/${workspace}/${namespace}`, { updates })
}

export function getStepConfig (workspace, step, section = 'model') {
  return mt().get(['get-step-config', workspace, step, section].join('/'))
}

export const setStepConfig = (workspace, step, section, config) => {
  return mt().put('set-step-config', {
    workspace,
    step,
    section,
    config
  })
}

export function updateStepConfig (workspace, step, section, command) {
  return mt().post('update-step-config', { workspace, step, section, command })
}

export const listStepConfigs = (workspace, section) => {
  return mt().get(['list-step-configs', workspace, section].join('/'))
}

export const listWorkspacesStepConfigs = (workspaces) => {
  return mt().post('list-workspaces-step-configs', { workspaces })
}

// TODO: get workspace under user's permission, filter on server side
// TODO: return workspace unique id
export function getWorkspaceList (type) {
  let args = {}
  if (type) args = { params: { type: type } }
  return mt().get('list-workspaces', args)
}

export const getWorkspaceFileList = (workspace) => {
  return mt().get('list-keys/' + workspace)
}

export const getWorkspaceMetaData = (workspace) => {
  return mt().get('workspace-metadata/' + workspace)
}

export const uploadRawFile = (workspace, file, callback) => {
  let path = require('path')
  var reader = new FileReader()
  reader.onload = () => {
    const ext = path.extname(file.name)
    const key = path.basename(file.name, ext)
    uploadFile(
      workspace,
      key,
      'raw' + ext,
      reader.result.split('base64,')[1],
      'clean|automate|infer',
      callback
    )
  }
  reader.readAsDataURL(file)
}

export const reloadKey = (workspace, key, methods) => {
  return mt().post('reload-key', { workspace, key, methods })
}

export const reIdentify = (workspace, key, step, options = {}, config_override = {}) => {
  return mt().post('re-identify', {
    workspace,
    key,
    step,
    options,
    config_override
  })
}

export const uploadFile = (workspace, key, filename, content, methods) => {
  return mt().put('upload-file', { workspace, key, filename, content, methods })
}

export const getKeyFile = (workspace, key, filename) => {
  return mt().post('get-key-file', {
    workspace,
    key,
    filename
  })
}

export const getKeyThumb = (workspace, key, filename) => {
  return mt().post('get-key-thumb', { workspace, key, filename })
}

export const getKeyFiles = (workspace, key, filenames) => {
  filenames = filenames.filter(x => x)
  return mt().post('get-key-files', {
    workspace,
    key,
    filenames
  })
}

export const getWorkspace = (workspace) => {
  return mt().get(['get-workspace', workspace].join('/'))
}

export const removeKeyFile = (workspace, key, filename) => {
  return mt().delete(['remove-key-file', workspace, key, filename].join('/'))
}

export const listFiles = (workspace, key, path) => {
  return mt().post('list-files', { workspace, key, path })
}

export const listFolders = (workspace, key, path) => {
  return mt().post('list-folders', { workspace, key, path })
}

export const getImageFile = (workspace, key, page, entries = null, options = null) => {
  return mt().post('get-image-file', { workspace, key, page, entries, options })
}

export const getImageFiles = (workspace, key, pages = null, entries = null, options = null) => {
  return mt().post('get-image-files', { workspace, key, pages, entries, options })
}

export const uploadImageFile = (workspace, key, page, entries) => {
  return mt().put('upload-image-file', { workspace, key, page, entries })
}

export const setImageMetadata = (workspace, key, page, step, metadata) => {
  return mt().put('set-image-metadata', { workspace, key, page, step, metadata })
}

export const autoInfer = (workspace, key, step, filenames, options = {}) => {
  filenames = filenames.filter(x => x)
  return mt().post('auto-infer', {
    workspace,
    key,
    step,
    filenames,
    options
  })
}

export const getKeyStatus = (workspace, key) => {
  return mt().get(['get-key-status', workspace, key].join('/'))
}

export const getKeysStatus = (workspace, keys) => {
  return mt().post('get-keys-status', {
    workspace,
    keys
  })
}

export const checkProcessingFiles = (workspace, keys) => {
  return mt().post('check-processing-files', {
    workspace,
    keys
  })
}

export const getSignOffFlag = (workspace, key, step) => {
  return mt().get(['get-sign-off-flag', workspace, key, step].join('/'))
}

export const setSignOffFlag = (workspace, key, step, flag) => {
  return mt().put(['set-sign-off-flag', workspace, key, step].join('/'), {
    flag
  })
}

export const getValidationFlag = (workspace, key, step) => {
  return mt().get(['get-validation-flag', workspace, key, step].join('/'))
}

export const setValidationFlag = (workspace, key, step, flag) => {
  return mt().put(['set-validation-flag', workspace, key, step].join('/'), {
    flag
  })
}

export const getFileWeight = (workspace, key, step) => {
  return mt().get(['get-file-weight', workspace, key, step].join('/'))
}

export const setFileWeight = (workspace, key, step, weight) => {
  return mt().put(['set-file-weight', workspace, key, step].join('/'), { weight })
}

export const createTrainSession = (workspace, step) => {
  return mt().post('create-train-session', {
    workspace,
    step
  })
}

export const startTraining = (session_id, options) => {
  return mt().post('start-training', {
    session_id,
    options
  })
}

export const stopTraining = (session_id, wait_seconds) => {
  return mt().post('stop-training', {
    session_id,
    wait_seconds
  })
}

export const listSessions = (workspace, step) => {
  return mt().post('list-sessions', {
    workspace,
    step
  })
}

export const listWorkspacesSessions = (workspaces, status) => {
  return mt().post('list-workspaces-sessions', {
    workspaces,
    status
  })
}

export const exportModel = (sessionId, name) => {
  return mt().post('export-model', {
    session_id: sessionId,
    name: name
  })
}

export function renameModel (workspace, step, name, new_name) {
  return mt().post('rename-model', { workspace, step, name, new_name })
}

export function renameKey (workspace, key, new_key) {
  return mt().post('rename-key', { workspace, key, new_key })
}

export const listModels = (workspace, step) => {
  return mt().get(['list-models', workspace, step].join('/'))
}

export const listPretrainedModels = (step) => {
  return mt().get(['list-pretrained-models', step].join('/'))
}

export const removeModel = (workspace, step, name) => {
  return mt().delete(['remove-model', workspace, step, name].join('/'))
}

export const removeSession = (session_id) => {
  return mt().delete(['remove-session', session_id].join('/'))
}

export const evaluateStep = (workspace, step, model, options, global = false) => {
  return mt().post('evaluate-step', {
    workspace,
    step,
    model,
    options,
    global
  })
}

export const inferStep = (workspace, key, step, model, options, global = false) => {
  return mt().post('infer-step', {
    workspace,
    step,
    key,
    model,
    options,
    global
  })
}

export const automateStep = (workspace, key, step, options = {}, config_override = {}) => {
  return mt().post('automate-step', {
    workspace,
    key,
    step,
    options,
    config_override
  })
}

export const automateWorkspace = (workspace, step, options = {}) => {
  return mt().post('automate-workspace', { workspace, step, options })
}

export const removeKey = (workspace, key) => {
  return mt().delete(['remove-key', workspace, key].join('/'))
}

export const modelDefaultOptions = (workspace, step) => {
  return mt().get(['model-default-options', workspace, step].join('/'))
}

export const observeModel = (workspace, step, model, options) => {
  return mt().post('observe-model', {
    workspace,
    step,
    model,
    options
  })
}
// type is one of ["session", "observe"], name is the session id or workspace name respectfully.
export const startTensorboard = (type, name) => {
  return mt().post('start-tensorboard', {
    type,
    name
  })
}

export const setDefaultModel = (workspace, step, name) => {
  return mt().post('set-default-model', {
    workspace,
    step,
    name
  })
}

export const getDefaultModel = (workspace, step) => {
  return mt().get(['get-default-model', workspace, step].join('/'))
}

export function exportPretrainedModel (workspace, step, name, rename) {
  return mt().post('export-pretrained-model', { workspace, step, name, rename })
}

export function migrateModel (ori_workspace, ori_step, ori_name, new_workspace, new_step, new_name) {
  return mt().post('migrate-model', { ori_workspace, ori_step, ori_name, new_workspace, new_step, new_name })
}

export const getUploadTimes = (workspace) => {
  return mt().get(['get-upload-times', workspace].join('/'))
}

export function ocrTextDetection (image, scale = 1) {
  return mt().post('ocr-text-detection', { image, scale })
}

export function ocrTextCNN (image, text_block) {
  return mt().post('ocr-text-cnn', { image, text_block })
}
